import DeleteIcon from '@mui/icons-material/Delete';

import ConfirmDialog from 'portal/src/components/common/ConfirmDialog';

const ConfirmDeleteDialog = ({
  disabled = false,
  isLoading,
  itemName = 'row',
  maxWidth,
  message,
  onClose,
  onConfirm,
  showDialog,
}: {
  disabled?: boolean;
  isLoading: boolean;
  itemName?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  message?: string | JSX.Element;
  onClose: () => void;
  onConfirm: () => void;
  showDialog: boolean;
}) => {
  return (
    <ConfirmDialog
      maxWidth={maxWidth}
      open={showDialog}
      onClose={onClose}
      message={message ?? `Are you sure you want to delete this ${itemName}?`}
      primaryButtonLabel="Delete"
      onPrimaryButtonClicked={onConfirm}
      primaryButtonColor="error"
      secondaryButtonLabel="Cancel"
      onSecondaryButtonClicked={onClose}
      renderElement={<DeleteIcon sx={{ color: 'error.main' }} />}
      isLoading={isLoading}
      primaryButtonDisabled={disabled}
    />
  );
};

export default ConfirmDeleteDialog;
